import { Fragment } from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import Footer from "src/components/shared/footer/Footer/Footer";
import TopNavigation from "src/components/shared/navigation/TopNavigation/TopNavigation";

function WithNavigationLayout() {
  const { footer } = useLoaderData();
  return (
    <Fragment>
      <TopNavigation />
      <Outlet />
      <Footer data={footer.data} />
    </Fragment>
  );
}

export default WithNavigationLayout;
